<template>
  <div class="dashboard-editor-container">
    <!-- <panel-group @handleSetLineChartData="handleSetLineChartData" /> -->
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <line-chart1 />
      </el-col>
    </el-row>
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <Map-Chart />
      </el-col>
    </el-row>
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <Inspectfleeingmap />
      </el-col>
    </el-row>
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <Inspectscanmap />
      </el-col>
    </el-row>
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <line-chart2 />
      </el-col>
    </el-row>
    <!-- <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <line-chart3 />
      </el-col>
    </el-row> -->
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <line-chart4 />
      </el-col>
    </el-row>
        <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <line-chart41 />
      </el-col>
    </el-row>
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <line-chart5 />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { authgeticp } from "@/api/orgin";
import PanelGroup from "./components/PanelGroup";
import Inspectfleeingmap from "./components/inspectfleeingmap";
import Inspectscanmap from "./components/inspectscanmap";
import MapChart from "./components/MapChart";
import LineChart1 from "./components/chartpage/LineChart1";
import LineChart2 from "./components/chartpage/LineChart2";
import LineChart3 from "./components/chartpage/LineChart3";
import LineChart4 from "./components/chartpage/LineChart4";
import LineChart41 from "./components/chartpage/LineChart41";
import LineChart5 from "./components/chartpage/LineChart5";
// import RaddarChart from "./components/RaddarChart";
// import PieChart from "./components/PieChart";
// import BarChart from "./components/BarChart";
// import TodoList from "./components/TodoList";
import { productlist, productTree } from "@/api/base";
export default {
  name: "DashboardAdmin",
  components: {
    Inspectscanmap,Inspectfleeingmap,
    PanelGroup,
    MapChart,
    LineChart1,
    LineChart2,
    LineChart3,
    LineChart4,
    LineChart41,
    LineChart5
    // RaddarChart,
    // PieChart,
    // BarChart,
    // TodoList
  },
  data() {
    return {
      lineChartData: {},
      // 扫码查询参数
      searchform: {
        productCode: null,
        datelist: null
      },
      productlist: [],
      barndlist: []
    };
  },

  methods: {},
  mounted() {
    // 图表初始数据调用
    productlist({ pageSize: 30 }).then(response => {
      this.productlist = response.data.data;
    });
    productTree().then(response => {
      this.barndlist = response.data;
    });
  }
};
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }
  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}
</style>
